$(document).ready(function(e){


  var $variants = $('.variant-custom-fields');
  var $form = $('form[action="/cart/add"]');


  // Set the active variant on page load.
  setActiveVariantCustomFields($form, $variants);
  setBoldHtml();
  
  // Toggle display when dropdown changed in the "Add to Cart" feature.
  $("body").on("change", 'form[action="/cart/add"]', function() {
      setActiveVariantCustomFields($(this), $('.variant-custom-fields'));
      setBoldHtml();        
  });
  
  $( "#colorbox" ).on("classChange", function(){
    setActiveVariantCustomFields($(this), $('.variant-custom-fields'));
  });
  
  /**
   * Sets the active variant based on the "id" select dropdown in the add to cart form.
   */
  function setActiveVariantCustomFields($form, $variants){
    $variants.hide();
    setTimeout(function(){
      var ids = $('input[name="properties[_boldVariantIds]"]').val()
      if (ids) {
        $.get(`https://cooklist.whatscookin.io/api/nutrition?ids=${ids}`, function (response) {
          showCustomItemNutrition(response)
        })
      }
      else {
        
        var totalCalories = 0
        var totalProtein = 0;
        var totalCarbs = 0;
        var totalFat = 0;
        var totalSodium = 0;
        var totalFiber = 0;
        var totalSugar = 0;
        
        var active_variant_id = $form.find('select[name="id"]').val();
        $variants.filter('[data-variant-id="'+ active_variant_id +'"]').show(); 
        $variants.each(function() {
          var calories = 0;
          if ($(this).is('[data-variant-id="'+ active_variant_id +'"]')) {
            if ($(this).find('[data-type="Protein"]').length) {
              calories += parseFloat($(this).find('[data-type="Protein"]').attr('data-qty') * 4);
              totalProtein += parseFloat($(this).find('[data-type="Protein"]').attr('data-qty'))
            }
            if ($(this).find('[data-type="Fat"]').length) {
              calories += parseFloat($(this).find('[data-type="Fat"]').attr('data-qty') * 9);
              totalFat += parseFloat($(this).find('[data-type="Fat"]').attr('data-qty'))
            }
            if ($(this).find('[data-type="Carbs"]').length) {
              calories += parseFloat($(this).find('[data-type="Carbs"]').attr('data-qty') * 4);
              totalCarbs += parseFloat($(this).find('[data-type="Carbs"]').attr('data-qty'))
            }        
            if ($(this).find('[data-type="Sodium"]').length) {
              totalSodium += parseFloat($(this).find('[data-type="Sodium"]').attr('data-qty'))
            }        
            if ($(this).find('[data-type="Fiber"]').length) {
              totalFiber += parseFloat($(this).find('[data-type="Fiber"]').attr('data-qty'))
            }        
            if ($(this).find('[data-type="Sugar"]').length) {
              totalSugar += parseFloat($(this).find('[data-type="Sugar"]').attr('data-qty'))
            }        
          }
          totalCalories += calories
          $(this).find('#calories').html(calories.toFixed());
        })
        $("#total_calories").html(totalCalories.toFixed());
        $("#total_protein").html(totalProtein.toFixed(1));
        $("#total_fat").html(totalFat.toFixed(1));
        $("#total_carbs").html(totalCarbs.toFixed(1));
        $("#total_sodium").html(totalSodium.toFixed(1));
        $("#total_fiber").html(totalFiber.toFixed(1));
        $("#total_sugar").html(totalSugar.toFixed(1));
        if (totalCalories) {
        	$(".ct-calories").html(`<strong>${totalCalories.toFixed()}</strong></br>Calories`);
        	buildCharts(totalProtein, totalCarbs, totalFat)
        }
        
      }
    }, 100);
  }
  
  function setBoldHtml() {
    setTimeout(function() {
    	$('.bold_option_value .bold_option_value_element').each(function(item) {
          $(this).find('span').html($(this).find('input').val())
        })
    }, 500);
  }
  function showCustomItemNutrition(data)
  {
    var html = `<table><thead><tr style="background-color: #ff6e00;">
        	<th style="padding: 0 10px 0 10px;">Item</th>
			<th style="padding: 0 10px 0 10px;">Calories</th>
			<th style="padding: 0 10px 0 10px;">Protein(g)</th>
			<th style="padding: 0 10px 0 10px;">Carbs(g)</th>
			<th style="padding: 0 10px 0 10px;">Fat(g)</th>
			<th style="padding: 0 10px 0 10px;">Sodium(mg)</th>
			<th style="padding: 0 10px 0 10px;">Fiber(g)</th>
			<th style="padding: 0 10px 0 10px;">Sugar(g)</th>
		</tr></thead><tbody>`
    
    var totalCalories = 0;
    var totalProtein = 0;
    var totalCarbs = 0;
    var totalFat = 0;
    var totalSodium = 0;
    var totalFiber = 0;
    var totalSugar = 0;
    var calories = 0

    for (var i = 0; i < data.length; i++) {
        calories = data[i]["1-protein"] *4 + data[i]["1-carbs"] * 4 + data[i]["1-fat"] *9
    	html += `
        <tr style="background-color: ${ i % 2 ? '#f2f2f2' : 'initial'}">
        	<td style="padding: 0 15px 0 0;">${data[i]["1-label"]}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${calories.toFixed()}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${parseFloat(data[i]["1-protein"], 10).toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${parseFloat(data[i]["1-carbs"], 10).toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${parseFloat(data[i]["1-fat"], 10).toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${parseFloat(data[i]["1-sodium"], 10).toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${parseFloat(data[i]["1-fiber"], 10).toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${parseFloat(data[i]["1-sugar"], 10).toFixed(1)}</td>
		</tr>`
        totalCalories += parseFloat(calories,10)
        totalProtein += parseFloat(data[i]["1-protein"], 10)
        totalCarbs += parseFloat(data[i]["1-carbs"], 10)
        totalFat += parseFloat(data[i]["1-fat"], 10)
        totalSodium += parseFloat(data[i]["1-sodium"], 10)
        totalFiber += parseFloat(data[i]["1-fiber"], 10)
        totalSugar += parseFloat(data[i]["1-sugar"], 10)
	}
    html += `
		<tr style="background-color: #ff6e00;">
        	<td style="padding: 0 15px 0 0;">Total</td>
			<td style="padding: 0 15px 0 0;text-align: right">${parseFloat(totalCalories, 10).toFixed()}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${totalProtein.toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${totalCarbs.toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${totalFat.toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${totalSodium.toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${totalFiber.toFixed(1)}</td>
			<td style="padding: 0 15px 0 0;text-align: right">${totalSugar.toFixed(1)}</td>
		</tr></tbody></table>`
    $('#nutrition').html(html)
    if (totalCalories) {
    	$(".ct-calories").html(`<strong>${totalCalories.toFixed()}</strong></br>Calories`);
      
      buildCharts(totalProtein, totalCarbs, totalFat)
    }
  }
  
  function buildCharts(totalProtein, totalCarbs, totalFat) {
    
    var totalCalories = totalProtein + totalCarbs + totalFat;
    
    $("#showNutrition").show();
  
    new Chartist.Bar('.ct-line.ct-chart', {
      labels: [
        `Protein (${totalProtein.toFixed(0)}g)`, 
        `Carbs (${totalCarbs.toFixed(0)}g)`, 
        `Fat (${totalFat.toFixed(0)}g)`
      ],
      series: [
        [
          {value: totalProtein.toFixed(1), className: 'ct-protein'}, 
          {value: totalCarbs.toFixed(1), className: 'ct-carbs'},
          {value: totalFat.toFixed(1), className: 'ct-fat'}]
      ]
    }, {
      seriesBarDistance: 10,
      reverseData: true,
      horizontalBars: true,
      axisY: {
        offset: 70
      }
    });

    new Chartist.Pie('.ct-donut.ct-chart', {
      series: [
        {value: totalProtein.toFixed(1), className: 'ct-protein'}, 
        {value: totalCarbs.toFixed(1), className: 'ct-carbs'},
        {value: totalFat.toFixed(1), className: 'ct-fat'}
      ],
      labels: [
        `Protein (${(totalProtein/totalCalories*100).toFixed(0)}%)`, 
        `Carbs  (${(totalCarbs/totalCalories*100).toFixed(0)}%)`, 
        `Fat  (${(totalFat/totalCalories*100).toFixed(0)}%)`],
    }, {
      donut: true,
      donutWidth: 30,
      startAngle: 270,
      showLabel: true,
      width: '200px',
      height: '200px'
    });
  }
  
  if (document.getElementById("showNutrition")) {
  
  	document.getElementById("showNutrition").addEventListener("click", function(event){
  		event.preventDefault()
	}); 
  }
  

});

function toggleNutrition() {
  var div = document.getElementById("nutrition");
  var button = document.getElementById("showNutrition");
  if (div.style.display === "none") {
    div.style.display = "block";
    button.innerHTML = "Hide Nutrition Details"
  } else {
    div.style.display = "none";
    button.innerHTML = "Show Nutrition Details"
  }
} 